export const COACH_REVIEWS_QUERY_KEY = "coach_reviews";
export const COACH_AVERAGE_RATINGS_QUERY_KEY = "coach_average_ratings";
export const CUSTOMER_REVIEW_QUERY_KEY = "customer_review";
export const CUSTOMER_CAN_EDIT_REVIEW_QUERY_KEY = "customer_can_edit_review";
